// extracted by mini-css-extract-plugin
export default {"description":"Description_description__OcZNO","background":"Description_background__-6wIC","image":"Description_image__faXcx","info":"Description_info__tWlVq"};